/**
 * 地块绘制工具
 */
import Base from "./Base";
import * as turf from '@turf/turf'
import {checkKinks} from "../../common/CommonFun";
import SimpleEditToolBar from "../control/SimpleEditToolBar";
import MapCommon from "../../common/MapCommon";
import { v4 as uuidv4 } from 'uuid'
import * as helpers from '@turf/helpers'
import {TOOL_DRAW_AREA} from "./ToolType";

export default class DrawArea extends Base {
  constructor(options) {
    let params={
      map:null,//地图实例
      showIcon: true,//是否展示图标
      iconCLassName: "iconfont-map map-icon-huizhi",//图标类名
      callBackName: "",//正常地图事件回调
      errorEventName: "",//错误地图事件回调
      chineseName: "绘制",//中文工具名称
      continueDraw:true,//是否连续绘制
      checkValid:false,//是否检测自相交
      showArea:false,//是否实时展示面积
      showLength:false,//是否实时展示周长
      showTool:false,//是否展示撤销工具条
      toolPosition:'top-right',//工具条位置,'top-left' ， 'top-right' ， 'bottom-left' ，和 'bottom-right' 。默认为 'top-right' 。
      callBack:null,
      errorCallBack:null,
      updateCallBack:null,
      updateEventName:null,
      showCross:false,
      cancelCallback: null,
      circleRadius: 7,
      circleStrokeWidth:2,
    }
    Object.assign(params,options)
    super(params.map,TOOL_DRAW_AREA,params);
    this.params=params;
    this.checkValid=params.checkValid;
    this.continueDraw=params.continueDraw;
    this.showArea=params.showArea;
    this.showLength=params.showLength;
    this.showTool=params.showTool;
    this.toolPosition=params.toolPosition;
    this.showCross=params.showCross;

    //初始化三个点的数组
    this.points = [];//当前绘制点
    this.pointsRedo = [];//已撤销的点
    this.currentPoint = null;//鼠标当前点

    this.sourceId = uuidv4();
    this.lineId = uuidv4();
    this.pointId = uuidv4();
    this.isReady=false;
    this.moveModel=false;//移动端加点拖动模式
  }

  start() {
    super.start();
    this.reset();
    this._addDrawLayer();
    this._addEvent();

    if(this.showTool){
      //显示工具条
      this.control=new SimpleEditToolBar(this._btnListener.bind(this));
      this.map.addControl(this.control, this.toolPosition)
    }
    //添加十字丝
    if(this.showCross){
      this.cross = document.createElement("div");
      this.cross.className = "_cross";
      this.map.getCanvas().parentNode.parentNode.appendChild(this.cross)
    }
  }

  /**
   * 工具条点击回调
   * @param type
   * @private
   */
  _btnListener(type){
    switch (type){
      case "cancel":this.cancel();break;
      case "undo":this.undo();break;
      case "redo":this.redo();break;
      case "addPoint":this.addPoint();this._startDrag();break;
      case "finish":this.drawFinish();break;
      default:break;
    }
  }

  /**
   * 取消绘制
   */
  cancel(){
   this.close();
    if(this.continueDraw){
      this.reset();
    }else {
      this.inActiveIcon()
    }
  }
  /**
   * 重做点
   */
  redo(){
    if (this.pointsRedo.length === 0) {
      return
    }
    this.points.push(this.pointsRedo[this.pointsRedo.length - 1]);
    this.pointsRedo.splice(this.pointsRedo.length - 1, 1);
    this._update();
  }

  /**
   * 绘制点
   */
  undo(){
    if (this.points.length === 0) {
      return
    }
    this.pointsRedo.push(this.points[this.points.length - 1]);
    this.points.splice(this.points.length - 1, 1);
    this._update();
  }

  /**
   * 绘制完成
   */
  drawFinish(){
    if(this.points.length<=3){
      console.error("点的数量少于三个")
      return null
    }
    this.currentPoint=null;
    this._update();
    let points=[].concat(this.points);
    points.push(this.points[0])
    let feature=helpers.polygon([points]);
    this.isReady=false;
    console.log("关闭")
    if(this.checkValid&&checkKinks(feature)){
      this.error("多边形自相交");
      console.error("多边形自相交")
      console.error(feature)
    }else {
      this.finish(feature)
    }
    if(this.continueDraw){
      this.reset();
    }else {
      this.inActiveIcon()
    }

  }

  /**
   * 地图数据清空
   */
  reset(){
    this.points = [];//当前绘制点
    this.pointsRedo = [];//已撤销的点
    this.currentPoint = null;//鼠标当前点
    this.isReady=true;
    console.log("重置")
    this.clearPopup();
    this._update();
  }


  /**
   * 取屏幕中心点添加
   */
  addPoint(){
    this.points.push(this.map.getCenter().toArray())
    this._update();
  }
  showAreaPopup(coordinates){
    this.clearPopup();
    let text="";
    if(this.showArea&&coordinates.length>3){
      let feature=helpers.polygon([coordinates])
      let area=turf.area(feature);
      text="面积："+(area*0.0015).toFixed(2)+"亩"
    }
    //长度取最后一条边的长度
    if(this.showLength){
      let line=turf.lineString([coordinates[coordinates.length-2],coordinates[coordinates.length-1]])
      if(coordinates.length>2){
        line=turf.lineString([coordinates[coordinates.length-3],coordinates[coordinates.length-2]])
      }

      let length = turf.length(line, { units: "kilometers" })*1000;
      if(text){
        text=text+"<br/>"
      }
      text=text+"长度："+length.toFixed(2)+"米"
    }
    let center=this.map.getCenter()
    this.addPopupHtml(text,turf.point([center.lng,center.lat]))
  }

  _startDrag(){
    //移动端和已经在拖动模式下，都不再继续
    if(!this.isMobile||this.moveModel){
      return;
    }
    this.moveModel=true;

    this._moveEvent = ({target}) => {
      let center=target.getCenter()
      this.currentPoint = [center.lng, center.lat];
      this._update();
      // this._preventDefault(e)
    };
    this.map.on("drag", this._moveEvent);
  }


  /**
   * 更新绘制效果
   * @private
   */
  _update() {
    //更改按钮状态
    if(this.control){
      // this.control.setPointLength(this.points.length)
      this.control.setPointLength(this.points.length,this.pointsRedo.length)
    }
    this._addPoints();


    let coordinates = [].concat(this.points);
    if(this.currentPoint){
      coordinates.push(this.currentPoint);
    }
    if(coordinates.length>0){
      coordinates.push(coordinates[0]);
    }

    if(!this.map.getSource(this.sourceId)){
      return
    }
    if(coordinates.length>3){
      let feature=helpers.polygon([coordinates])
      this.map.getSource(this.sourceId).setData(feature);
      if(this.updateCallBack){
        this.updateCallBack(feature)
      }
      if(this.updateEventName){
        this.map.fire(this.updateEventName,feature)
      }
    }else {
      this.clearPopup()
      this.map.getSource(this.sourceId).setData(helpers.featureCollection([]));
    }
    if(coordinates.length>2){
      if(this.showArea||this.showLength){
        this.showAreaPopup(coordinates)
      }
      let line=helpers.lineString(coordinates)
      this.map.getSource(this.lineId).setData(line);
    }else {
      this.map.getSource(this.lineId).setData(helpers.featureCollection([]));
    }



  }
  /**
   * 绘制节点
   * @private
   */
  _addPoints(){

    let features=[]
    for (let i = 0; i < this.points.length; i++) {
      features.push(helpers.point(this.points[i],{index:i}))
    }
    let featureCollection=helpers.featureCollection(features)
    if(this.map.getSource(this.pointId)){
      this.map.getSource(this.pointId).setData(featureCollection);
    }else {
      this.map.addSource(this.pointId, {
        "type": "geojson",
        "data": featureCollection
      });
    }
    if(!this.map.getLayer(this.pointId)){
      this.map.addLayer({
        id: this.pointId,
        type: "circle",
        source: this.pointId,
        layout: {visibility:"visible"},
        paint: {
          "circle-color": "#0FF",
          "circle-radius": this.params.circleRadius,
          "circle-stroke-width":this.params.circleStrokeWidth,
          "circle-stroke-color":"#FFF"
        },
      });
      this.map.on("click",this.pointId,()=>{
        this._dbClickEvent({type:"dblclick"})
      })
    }
  }

  /**
   * 移除长度文字
   */
  clearPopup(){
    if(this.popup){
      this.popup.remove();
      this.popup=null;
      super.clearPopup();
    }
  }
  close() {
    this.clear();
    this.clearEvent();
    //移除编辑组件
    if(this.control){
      this.map.removeControl(this.control)
      this.control=null;
    }
    //移除十字丝
    if(this.cross){
      this.cross.parentNode.removeChild(this.cross);
      this.cross=null
    }

  }

  clear() {
    this.clearPopup();
    this.clearMap();
  }

  clearMap() {
    this.points = [];//当前绘制点
    this.pointsRedo = [];//已撤销的点
    this.currentPoint = null;//鼠标当前点
    this._removeDrawLayer();
  }



  _addEvent(){
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent);
    this._dbClickEvent = (e) => {
      console.log("双击")
      console.log(e)
      if(this.points.length>3){
        // if(e.type=="dblclick"){
        //   this.points.splice(this.points.length-1, 1)
        // }
        this.drawFinish();
      }
      this._preventDefault(e);
    };
    this._clickEvent = (e) => {

      if(!this.isReady){
        return;
      }


      if(e._defaultPrevented){
        return;
      }
      console.log("点击",this.isReady)
      this._preventDefault(e);
      if(this.clickBufferTime){
        this.clickBufferTime=false
        this._dbClickEvent({type:"dblclick"})
      }else if(this.isMobile) {
        this.points.push([e.lngLat.lng, e.lngLat.lat])
        this._update();
        this.clickBufferTime=true;
        setTimeout(()=>{
          this.clickBufferTime=false;
        },300)
      }else {
        this.points.push([e.lngLat.lng, e.lngLat.lat])
        this._update();
      }
    };
    this.map.on("click", this._clickEvent);


    this.map.on("contextmenu", this._dbClickEvent);

    if(!this.isMobile){
      this._moveEvent = (e) => {
        this.currentPoint = [e.lngLat.lng, e.lngLat.lat];
        this._update();
        this._preventDefault(e)
      };
      this.map.on("mousemove", this._moveEvent);
    }
    //关闭双击缩放d
    this._doubleClickZoom=this.map.doubleClickZoom.isEnabled()
    if(this._doubleClickZoom){
      this.map.doubleClickZoom.disable();
    }
    this._defaultContextmenu=this.map.getCanvas().oncontextmenu;
    this.map.getCanvas().oncontextmenu = function (event) {
      event.preventDefault();
    };
    this._defaultCursor=this.map.getCanvas().style.cursor;
    this.map.getCanvas().style.cursor="crosshair";
  }

  clearEvent() {
    super.clearEvent();
    if (this._clickEvent) {
      this.map.off("click", this._clickEvent);
      this._clickEvent = undefined
    }
    if (this._moveEvent&&!this.isMobile) {
      this.map.off("mousemove", this._moveEvent);
      this._moveEvent = undefined
    }
    if (this._dbClickEvent) {
      this.map.off("contextmenu", this._dbClickEvent);
      this._dbClickEvent = undefined
    }
    if(this.isMobile&&this.moveModel&&this._moveEvent){
      this.moveModel=false;
      this.map.off("drag", this._moveEvent);
    }



    console.log("移除事件")
    this.cancels()
    //启用双击缩放
    if(this._doubleClickZoom){
      this.map.doubleClickZoom.enable()
    }
    //恢复地图右键事件
    this.map.getCanvas().oncontextmenu=this._defaultContextmenu;
    this.map.getCanvas().style.cursor=this._defaultCursor;

  }

  //添加绘制图层
  _addDrawLayer() {

    if (!this.map.getSource(this.sourceId)) {
      this.map.addSource(this.sourceId, {
        type: "geojson",
        data: helpers.featureCollection([]),
      });
    }

    if (!this.map.getSource(this.lineId)) {
      this.map.addSource(this.lineId, {
        type: "geojson",
        data: helpers.featureCollection([]),
      });
    }

    if (!this.map.getLayer(this.sourceId)) {
      this.map.addLayer({
        id: this.sourceId,
        type: "fill",
        source: this.sourceId,
        layout: {},
        paint: {
          'fill-color': '#fbb03b',
          'fill-outline-color': '#fbb03b',
          'fill-opacity': 0.1
        },
      });
    }
    if (!this.map.getLayer(this.lineId)) {
      this.map.addLayer({
        id: this.lineId,
        type: "line",
        source: this.lineId,
        layout: {},
        paint: {
          'line-color': '#fbb03b',
          'line-dasharray': [1, 1],
          'line-width': 2
        }
      });
    }
  }

  /**
   * 移除绘制图层
   * @private
   */
  _removeDrawLayer() {
    MapCommon.removeLayer(this.map, this.sourceId);
    MapCommon.removeLayer(this.map, this.lineId);
    this.map.off("click", this.pointId)
    MapCommon.removeLayer(this.map, this.pointId);
    MapCommon.removeSource(this.map, this.sourceId);
    MapCommon.removeSource(this.map, this.lineId);
    MapCommon.removeSource(this.map, this.pointId);
  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/DrawArea.js